
import { createSlice } from "@reduxjs/toolkit";
import { faqsGet } from "reduxStore/actions/faqs";

const initialState = {
    userLoading: false,  
    faqs: [],
    error: null
}

const faqSlice = createSlice({
    name: 'faqs',
    initialState,
    reducers: {
       
    },
    extraReducers: builder => {
        builder
        .addCase(faqsGet.pending, (state) => {
            state.userLoading = true; 
            state.error = null;
        })
        .addCase(faqsGet.fulfilled, (state, action) => {
            state.userLoading = false; 
            if (action.payload?.success && action.payload?.data?.rows) {
                state.faqs = action.payload.data.rows;
            } else {
                state.error = action.payload?.message || "Failed to fetch FAQs";
            }
        })
        .addCase(faqsGet.rejected, (state, action) => {
            console.error("Error fetching FAQs:", action.error.message);
            state.userLoading = false;  // Use userLoading to match your component
            state.error = action.error.message;
        });
    }
});

export default faqSlice.reducer;